export const CONSOLE = Object.freeze({
  ACTIONS: 'ACTIONS',
  ADD_USERS_TO_GROUP: 'ADD_USERS_TO_GROUP',
  ADD_USERS_TO_REPORT: 'ADD_USERS_TO_REPORT',
  ADD_USERS_TO_SITE: 'ADD_USERS_TO_SITE',
  ADMIN: 'ADMIN',
  ALL_POLICIES: 'ALL_POLICIES',
  APPROVE_VULN_EXCEPTIONS: 'APPROVE_VULN_EXCEPTIONS',
  ASSET: 'CONSOLE_ASSET',
  ASSIGN_TICKET_ASSIGNEE: 'ASSIGN_TICKET_ASSIGNEE',
  CLOSE_TICKETS: 'CLOSE_TICKETS',
  CONFIGURE_ASSET_GROUP: 'CONFIGURE_ASSET_GROUP',
  CONFIGURE_GLOBAL_SETTINGS: 'CONFIGURE_GLOBAL_SETTINGS',
  CONFIGURE_SITE_SCAN_ALERTS: 'CONFIGURE_SITE_SCAN_ALERTS',
  CONFIGURE_SITE_SCAN_CREDENTIALS: 'CONFIGURE_SITE_SCAN_CREDENTIALS',
  CONFIGURE_SITE_SCAN_ENGINE: 'CONFIGURE_SITE_SCAN_ENGINE',
  CONFIGURE_SITE_SCAN_TEMPLATE: 'CONFIGURE_SITE_SCAN_TEMPLATE',
  CONFIGURE_SITE_SETTINGS: 'CONFIGURE_SITE_SETTINGS',
  CONFIGURE_SITE_TARGETS: 'CONFIGURE_SITE_TARGETS',
  CREATE_REPORTS: 'CREATE_REPORTS',
  CREATE_TICKETS: 'CREATE_TICKETS',
  DELETE_ASSETS: 'DELETE_ASSETS',
  DELETE_VULN_EXCEPTIONS: 'DELETE_VULN_EXCEPTIONS',
  EXCLUDE_IPIMS_FOR_ALL_USERS: 'EXCLUDE_IPIMS_FOR_ALL_USERS',
  GENERATE_RESTRICTED_REPORTS: 'GENERATE_RESTRICTED_REPORTS',
  HOME: 'HOME',
  MANAGE_ASSET_GROUPS: 'MANAGE_ASSET_GROUPS',
  MANAGE_DYNAMIC_ASSET_GROUPS: 'MANAGE_DYNAMIC_ASSET_GROUPS',
  MANAGE_POLICIES: 'MANAGE_POLICIES',
  MANAGE_REPORT_TEMPLATES: 'MANAGE_REPORT_TEMPLATES',
  MANAGE_REPORTS: 'MANAGE_REPORTS',
  MANAGE_SCAN_ENGINES: 'MANAGE_SCAN_ENGINES',
  MANAGE_SCAN_TEMPLATES: 'MANAGE_SCAN_TEMPLATES',
  MANAGE_SITES: 'MANAGE_SITES',
  MANAGE_STATIC_ASSET_GROUPS: 'MANAGE_STATIC_ASSET_GROUPS',
  MANAGE_TAGS: 'MANAGE_TAGS',
  MANAGE_VULN_INVESTIGATIONS: 'MANAGE_VULN_INVESTIGATIONS',
  POLICIES: 'POLICIES',
  REPORTS: 'CONSOLE_REPORTS',
  SCAN_SITE: 'SCAN_SITE',
  SCHEDULE_SITE_SCANS: 'SCHEDULE_SITE_SCANS',
  SUBMIT_VULN_EXCEPTIONS: 'SUBMIT_VULN_EXCEPTIONS',
  TICKETS: 'TICKETS',
  VIEW_ASSET_GROUP: 'VIEW_ASSET_GROUP',
  VIEW_SITE: 'VIEW_SITE',
  VIEW_VULN_INVESTIGATIONS: 'VIEW_VULN_INVESTIGATIONS',
  VULNERABILITY: 'CONSOLE_VULNERABILITY',
});

export const EXPOSURE_ANALYTICS = Object.freeze({
  AGENT_POLICY: 'AGENT_POLICY',
  AGENTS: 'AGENTS',
  ALL_PRIVILEGES: 'ALL_PRIVILEGES',
  ASSET: 'ASSET',
  AUTOMATION: 'AUTOMATION',
  AUTOMATION_WRITE: 'AUTOMATION_WRITE',
  AWS: 'AWS',
  AWS_EXPIRED: 'AWS_EXPIRED',
  CONSOLE_DISABLED: 'CONSOLE_DISABLED',
  CONSOLE_EXPIRED: 'CONSOLE_EXPIRED',
  CONSOLE_PAIRING: 'CONSOLE_PAIRING',
  CONTAINER: 'CONTAINER',
  DASHBOARD: 'DASHBOARD',
  GOALS: 'GOALS',
  INFRASTRUCTURE: 'INFRASTRUCTURE',
  MANAGEMENT: 'MANAGEMENT',
  PLATFORM_LOGIN: 'PLATFORM_LOGIN',
  POLICY: 'POLICY',
  REMEDIATION: 'REMEDIATION',
  REPORTS: 'REPORTS',
  VULNERABILITY: 'VULNERABILITY',
});

export const UserPrivilege = Object.freeze({
  CONSOLE,
  ...EXPOSURE_ANALYTICS,
});
